
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/faq",
      function () {
        return require("private-next-pages/rims/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/faq"])
      });
    }
  